<script>
export default {
  components: {},
  props: {
    isDraft: {
      type: Boolean,
      required: true,
    },
    isFlagged: {
      type: Boolean,
      required: true,
      default: false,
    },
    isPublishedFlagged: {
      type: Boolean,
      required: true,
      default: false,
    },
    isDraftFlagged: {
      type: Boolean,
      required: true,
      default: false,
    },
    status: {
      type: String,
      required: true,
      default: () => '',
    },
    statusText: {
      type: String,
      required: true,
      default: () => '',
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="recipe-status-wrapper">
    <div
      :class="[
        'recipe-status draft',
        { draft: isDraft, flagged: isPublishedFlagged },
      ]"
    >
      <span v-if="isDraftFlagged"
        ><BaseIcon class="icon-flag" name="flag"
      /></span>
      {{ status }}
    </div>
    <p>{{ statusText }}</p>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.recipe-status-wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;

  .recipe-status {
    align-items: center;
    border-radius: 0.5rem;
    color: white;
    display: flex;
    font-size: 1.2rem;
    font-weight: 800;
    height: 3.2rem;
    justify-content: center;
    letter-spacing: 0.1px;
    line-height: 1.6rem;
    padding: 0.3rem 0.9rem;
    position: relative;
    text-transform: uppercase;
    width: 28.6rem;

    &.draft {
      background-color: black;

      .icon-flag {
        left: 1rem;
        position: absolute;
        top: 1rem;
      }
    }

    &.flagged {
      background-color: $color-red;
    }
  }

  p {
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 0.116667px;
    line-height: 2.4rem;
    margin-bottom: 0;
    opacity: 0.5;
  }
}
</style>
